import {
  CompanyDomain,
  CompanyDomainFilterInputObject,
  CompanyDomainsQueryVariables,
  useCompanyDomainsQuery,
} from 'graphql-common';
import _get from 'lodash/get';
import { GetUrlParams } from '@lib/enums/urls';
import createSearchFilters from '@lib/utils/createSearchFilters';
import { ListQueryHookProps, ListQueryResultWithoutIds } from '../types';

export default function useCompanyDomainsQueryHook({
  additionalFilters,
  fetchPolicy = 'cache-and-network',
  paginationParams,
  orderingParams,
  searchQuery,
  skip,
  usePrevious = true,
}: ListQueryHookProps): ListQueryResultWithoutIds<CompanyDomain> {
  const page = _get(paginationParams, GetUrlParams.Page);
  const perPage = _get(paginationParams, GetUrlParams.PerPage);
  const orderingField = _get(orderingParams, GetUrlParams.OrderingField);
  const orderingDirection = _get(
    orderingParams,
    GetUrlParams.OrderingDirection,
  );
  const queryVariables: CompanyDomainsQueryVariables = {
    page: Number(page),
    limit: Number(perPage),
  };
  const filters: CompanyDomainFilterInputObject[] = [
    ...((additionalFilters as CompanyDomainFilterInputObject[]) || []),
  ];
  if (searchQuery) {
    filters.push(
      ...createSearchFilters(searchQuery, [{ fieldName: 'domain' }]),
    );
  }
  if (filters.length) {
    queryVariables.filters = filters;
  }
  if (orderingField && orderingDirection) {
    queryVariables.sorts = {
      [orderingField]: orderingDirection,
    };
  }
  const query = useCompanyDomainsQuery({
    fetchPolicy,
    variables: queryVariables,
    skip,
  });
  const { loading, data, previousData, refetch, error } = query;
  const queryData = usePrevious ? data || previousData : data;
  const firstLoading = loading && previousData === undefined;
  const collection = _get(queryData, 'data.collection', []) as CompanyDomain[];
  const metadata = _get(queryData, 'data.metadata');
  const totalCount = _get(metadata, 'totalCount', 0);
  const totalPages = _get(metadata, 'totalPages', 1);

  return {
    refetch,
    collection,
    error,
    firstLoading,
    loading,
    totalPages,
    totalCount,
  };
}
